// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const onlineDataSlice = createSlice({
  name: 'online',
  initialState: {
    socket: ""
  },
  reducers: {
    handleSocket: (state, action) => {
      state.socket = action.payload
    }
  }
})

export const { handleSocket } = onlineDataSlice.actions

export default onlineDataSlice.reducer
